import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { IKImage } from "imagekitio-react";
import { useSelector } from "react-redux";

const SearchResultsDropdown = ({
  results,
  isEmpty,
  setSearchString,
  noSearch,
  searchString,
}) => {
  const { skills, mskills, personalized_courses } = results;
  const email = useSelector((store) => store?.profileDetails?.email);
  const noResultFeatures = [
    "Personalised Syllabus",
    "Practical Projects",
    "Industry Certification",
    "Lifetime Access",
  ];
  console.log("rr", noSearch);
  if (!isEmpty) {
    return (
      <ul className="z-50 h-fit w-full list-none rounded-none bg-white p-1 shadow-none md:absolute md:top-10 md:left-0 md:right-0 md:w-full md:rounded md:shadow-xl">
        {personalized_courses
          ?.filter((item, idx) => idx <= 5)
          .map((personalize_item, idx) => (
            <Link
              to={""}
              replace
              key={idx}
              onClick={() => {
                setSearchString("");
                window.open(
                  `https://personalise.learntube.ai/welcome?email=${email}&skill_name=${encodeURIComponent(
                    personalize_item["skill_name"],
                  )}&utm_source=webapp-navbar&utm_medium=search-result`,
                  "_blank",
                );
              }}
            >
              <li className="flex cursor-pointer items-center justify-start gap-2 rounded border-b border-gray-100 px-4 py-3 hover:bg-gray-50 hover:text-[#06769E] md:border-b-0 md:px-1 md:py-2 md:hover:bg-teal-600 md:hover:text-white">
                <FontAwesomeIcon icon={faSearch} />
                <span className="flex-1 truncate text-sm">
                  {personalize_item["skill_name"]}
                </span>
                <span className="w-18 flex shrink-0 items-center justify-center rounded-full border-2 border-[#1F90CF] p-1.5 text-center text-supertiny font-bold md:hover:text-white">
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    src={
                      "https://img.learntube.ai/public-assets/Learntube/Group%2010100.svg?updatedAt=1705835753580"
                    }
                    className="mr-1 h-[18px] w-[18px]"
                  />
                  Personalised Course
                </span>
              </li>
            </Link>
          ))}
        {skills
          .filter((item, idx) => idx <= 5)
          .map((skill_item, idx) => (
            <Link
              key={idx}
              to={`/${skill_item["course_slug"]}/${skill_item["skill_slug"]}`}
              onClick={() => setSearchString("")}
              replace
            >
              <li className="flex cursor-pointer items-center justify-start gap-2 rounded border-b border-gray-100 px-4 py-3 hover:bg-gray-50 hover:text-[#06769E] md:border-b-0 md:px-1 md:py-2 md:hover:bg-teal-600 md:hover:text-white">
                <FontAwesomeIcon icon={faSearch} />
                <span className="flex-1 text-sm">
                  {skill_item["skill-name"]}
                </span>
                <span className="w-12 shrink-0 rounded-full border-2 border-orange-500 p-1.5 text-center text-supertiny font-bold md:hover:text-white">
                  Skill
                </span>
              </li>
            </Link>
          ))}
        {mskills
          .filter((item, idx) => idx <= 5)
          .map((mskill_item, idx) => (
            <Link
              to={`/${mskill_item["course_slug"]}/${mskill_item["skill_slug"]}/${mskill_item.mskill_slug}/${mskill_item.first_lesson?.id}`}
              replace
              key={idx}
              onClick={() => {
                setSearchString("");
              }}
            >
              <li className="flex cursor-pointer items-center justify-start gap-2 rounded border-b border-gray-100 px-4 py-3 hover:bg-gray-50 hover:text-[#06769E] md:border-b-0 md:px-1 md:py-2 md:hover:bg-teal-600 md:hover:text-white">
                <FontAwesomeIcon icon={faSearch} />
                <span className="flex-1 truncate text-sm">
                  {mskill_item["mSkill-name"]}
                </span>
                <span className="w-18 shrink-0 rounded-full border-2 border-teal-500 p-1.5 text-center text-supertiny font-bold md:hover:text-white">
                  Micro-skill
                </span>
              </li>
            </Link>
          ))}
      </ul>
    );
  } else {
    return (
      <ul className="z-50 h-fit w-full list-none rounded-none bg-white p-3 shadow-none md:absolute md:top-10 md:left-0 md:right-0 md:w-full md:rounded-xl md:p-1 md:shadow-xl">
        <li className="flex w-full flex-col items-center justify-center rounded px-1 py-2 md:px-2">
          <span className="text-[14px] font-medium text-[#4A5A70] md:text-[16px]">
            No matches found
          </span>
          <div className="mt-4 flex w-full flex-col items-center justify-center rounded-2xl bg-[#D4F4FF] p-4 md:p-3">
            <div className="flex items-center justify-center text-center text-[18px] font-medium sm:text-[20px] md:text-[24px]">
              {window?.innerWidth < 768 && (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Learntube/Group%2010118.svg?updatedAt=1706772449470"
                  }
                  className="mr-3 h-full w-[16%] shrink-0"
                />
              )}
              <span className="leading-tight">
                Create Personalised Course For
                <span className="ml-1 font-bold text-[#1F90CF]">
                  {noSearch}
                </span>
              </span>{" "}
            </div>
            <div className="mt-4 flex w-full items-center justify-between gap-4 px-0 md:w-[95%] md:px-8">
              {window?.innerWidth >= 768 && (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Learntube/Group%2010118.svg?updatedAt=1706772449470"
                  }
                  className="h-full"
                />
              )}
              <div className="w-full flex-1 rounded-xl bg-[#B3EBFF] py-4 px-3 md:w-auto">
                <div className="text-[15px] font-semibold text-[#12546B] md:text-[16px]">
                  What’s Included:
                </div>
                <div className="mt-2 grid grid-cols-2 grid-rows-2 gap-3 md:gap-2">
                  {noResultFeatures?.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-start"
                    >
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src={
                          "https://img.learntube.ai/public-assets/Learntube/Group%2010120.svg?updatedAt=1706773166935"
                        }
                        className="mr-1 md:mr-2"
                      />
                      <div className="whitespace-nowrap font-montserrat text-[12px] font-medium text-[#1A6D8A] md:text-[12px]">
                        {item}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="mt-6 flex w-full items-center justify-between gap-2 px-1 md:w-[95%] md:px-8">
              <div className="flex items-center justify-center">
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Learntube/Group%2010100.svg?updatedAt=1705835753580"
                  }
                  className="mr-1 h-[18px] w-[18px] shrink-0"
                />
                <div className="whitespace-nowrap text-[12px] font-semibold text-[#1F90CF] md:text-[14px]">
                  LearnTubeX Feature
                </div>
              </div>
              <button
                className="shrink-0 cursor-pointer rounded-lg bg-[#13B284] py-2 px-4 text-[12px] font-semibold text-white md:px-10 md:text-[14px]"
                onClick={(e) =>
                  window.open(
                    `https://personalise.learntube.ai?skill_slug=${noSearch}&utm_source=webapp-navbar&utm_medium=search-result`,
                  )
                }
              >
                Personalise Now!
              </button>
            </div>
          </div>
        </li>
      </ul>
    );
  }
};

export default SearchResultsDropdown;
